// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "lead_form".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { leadFormStatusValues } from '@borradh-workspace/labels';
/** Response atom for the "lead_form" table (1:1 with a DB row, on the wire). */
export const leadFormAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    name: z.string(),
    status: z.enum(leadFormStatusValues),
    questions: z.unknown(),
    privacyPolicyUrl: z.string(),
    privacyPolicyLinkText: z.string().nullable(),
    thankYouTitle: z.string().nullable(),
    thankYouBody: z.string().nullable(),
    thankYouButtonText: z.string().nullable(),
    thankYouButtonUrl: z.string().nullable(),
    followUpChannel: z.string(),
    whatsappNumber: z.string().nullable(),
    metaFormId: z.string().nullable(),
    metaPageId: z.string().nullable(),
    lastSyncAt: z.string().datetime().nullable(),
    syncError: z.string().nullable(),
    metaVersions: z.unknown(),
    publication: z.unknown().nullable(),
    intro: z.unknown().nullable(),
    organizationServiceId: z.string().nullable(),
    serviceLinkSource: z.string().nullable(),
    createdById: z.string().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=leadForm.js.map